import { render, staticRenderFns } from "./WeatherWidgetVertical.vue?vue&type=template&id=60ad5b0e&scoped=true"
import script from "./WeatherWidgetVertical.vue?vue&type=script&lang=js"
export * from "./WeatherWidgetVertical.vue?vue&type=script&lang=js"
import style0 from "./WeatherWidgetVertical.vue?vue&type=style&index=0&id=60ad5b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad5b0e",
  null
  
)

export default component.exports